import React from 'react';
import {useTranslation} from 'react-i18next';
import {NavigationLink} from "../types";
import Navigation from "./Navigation";
import Branding from "./Branding";
import LoginSection from "./LoginSection";
import LanguageSwitcher from "./LanguageSwitcher";

import {UserRole} from "../../admin/users/types/User";

const TopBar: React.FC = () => {
  const { t } = useTranslation();

  const defaultNavigationLinks: NavigationLink[] = [
    {label: t('common.components.TopBar.navigation.home'), path: '/home'},
    {label: t('common.components.TopBar.navigation.collections'), path: '/browse-collections'},
    {label: t('common.components.TopBar.navigation.locations'), path: '/locations'},
    {label: t('common.components.TopBar.navigation.gallery'), path: '/gallery'},
    {label: t('common.components.TopBar.navigation.about'), path: '/page/about'},
    {
      label: t('common.components.TopBar.navigation.administration'),
      path: '/places',
      requiresAuth: true,
      allowedRoles: [UserRole.ADMIN, UserRole.REDACTOR]
    }
  ];

  return (
    <header id="header" className="bg-black text-white shadow-md">
      <div className="container mx-auto px-4 py-3">
        <div className="flex justify-between items-center">
          <Branding/>

          <Navigation links={defaultNavigationLinks}/>

          <div className="flex items-center gap-4">
            <LanguageSwitcher/>
            <LoginSection/>
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopBar;
